module.exports = __webpack_public_path__ + "img/btn.a2976dbc.png";